import { ErrorMessage } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import { $show } from '../model'
import { $notificationTranslations } from './translations'

export interface IPolicyMessage {
  absolute?: boolean
}

export const PolicyMessage = ({ absolute = false }: IPolicyMessage) => {
  const { title } = useUnit($notificationTranslations)

  const isShown = useUnit($show)

  return isShown ? (
    <ErrorMessage
      warning
      width='100%'
      zIndex={3}
      position={absolute ? 'absolute' : 'sticky'}
      title={title}
    />
  ) : null
}
